import { render, staticRenderFns } from "./frecord.vue?vue&type=template&id=510ba5fc&scoped=true"
import script from "./frecord.vue?vue&type=script&lang=js"
export * from "./frecord.vue?vue&type=script&lang=js"
import style0 from "./frecord.vue?vue&type=style&index=0&id=510ba5fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ba5fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510ba5fc')) {
      api.createRecord('510ba5fc', component.options)
    } else {
      api.reload('510ba5fc', component.options)
    }
    module.hot.accept("./frecord.vue?vue&type=template&id=510ba5fc&scoped=true", function () {
      api.rerender('510ba5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/frecord.vue"
export default component.exports